// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_br-0";